export const ModelIndexes = Object.freeze({
  CONTENT_LIBRARY: 0,
  TABLE_MODEL_INDEX: 1,
  INDEXATION_MODEL_INDEX: 2,
  CUSTOM_BUILD_INDEX: 3,
  CONSTANT_LINE: 4,
  CUSTOMIZE_OPTIONS: 5,
  SUMMARY_TABLE: 6,
  SMALL_LINE_CHART: 7,
  CALL_OUT_BOXES: 8,
  BACKGROUND_SHADING_TABLE_PANEL: 9,
  VERTICAL_LINE_TABLE_PANEL: 10,
  FORMAT_TEMPLATE: 11,
});
export const ModelsCount = Object.keys(ModelIndexes).length;
export type modalType =
  | "company"
  | "APALCompany"
  | "periodSummaryTable"
  | "ShadingPeriodTable"
  | "verticalLineTable"
  | "CallOutBox"
  | null;
